module.exports = __webpack_public_path__ + "img/img-administrator.e9360d94.png";